import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = {
  key: 1,
  class: "w-full flex flex-col"
}
const _hoisted_2 = {
  key: 2,
  class: "grid gap-6 w-full"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "flex flex-row mt-2 items-center" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4 pt-0.5 max-w-none",
  alt: "exclamation tiangle red"
}, null, -1)
const _hoisted_6 = { class: "text-red-lp-1200 text-14px xxl:text-16px pl-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_CargoTypeCard = _resolveComponent("CargoTypeCard")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.cargoAvailable)
      ? (_openBlock(), _createBlock(_component_EmptyState, {
          key: 0,
          icon: "cargo-unavailable",
          customMessage: _ctx.$t('cargo.notFoundCargoType')
        }, null, 8, ["customMessage"]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode(_component_skeleton, {
            width: "600px",
            height: "40px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-10",
            width: "800px",
            height: "40px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-3",
            width: "700px",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-3",
            width: "500px",
            height: "20px"
          }),
          _createVNode(_component_skeleton, {
            class: "mt-3",
            width: "800px",
            height: "20px"
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.cargoOptions.length)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cargoOptions, (option, index) => {
            return (_openBlock(), _createBlock(_Fragment, { key: option }, [
              (option === 'truck' || option === 'train')
                ? (_openBlock(), _createBlock(_component_CargoTypeCard, {
                    key: 0,
                    icon: _ctx.cargoType(option).icon,
                    type: _ctx.cargoType(option).label,
                    origin: _ctx.originCity.name,
                    isActive: _ctx.isOptionActive(option, 'manual'),
                    destination: _ctx.destinationCity.label,
                    onClick: () => _ctx.showPopupMaxKoliPlane(option, 'manual')
                  }, null, 8, ["icon", "type", "origin", "isActive", "destination", "onClick"]))
                : _createCommentVNode("", true),
              (option === 'plane-manual' && !_ctx.$route.query?.rcId)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode(_component_CargoTypeCard, {
                      icon: "cargo-plane",
                      type: "Pesawat",
                      origin: _ctx.originCity.name,
                      isActive: _ctx.isOptionActive('plane', 'manual'),
                      destination: _ctx.destinationCity.label,
                      onClick: _cache[1] || (_cache[1] = () => _ctx.showPopupMaxKoliPlane('plane', 'manual'))
                    }, null, 8, ["origin", "isActive", "destination"]),
                    _createVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('Jika memilih booking manual. Anda harus booking terlebih dulu di sistem nGen.')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (option === 'plane')
                ? (_openBlock(), _createBlock(_component_CargoTypeCard, {
                    key: 2,
                    isManual: false,
                    icon: _ctx.cargoType(option).icon,
                    type: _ctx.cargoType(option).label,
                    origin: _ctx.originCity.name,
                    destination: _ctx.destinationCity.label,
                    isActive: _ctx.isOptionActive(option, 'auto'),
                    onClick: () => _ctx.showPopupMaxKoliPlane(option, 'auto')
                  }, null, 8, ["icon", "type", "origin", "destination", "isActive", "onClick"]))
                : _createCommentVNode("", true),
              (index === _ctx.cargoOptions.length - 1 && option === 'ship')
                ? (_openBlock(), _createBlock(_component_CargoTypeCard, {
                    key: 3,
                    icon: _ctx.cargoType(option).icon,
                    type: _ctx.cargoType(option).label,
                    origin: _ctx.originCity.name,
                    isActive: _ctx.isOptionActive(option),
                    destination: _ctx.destinationCity.label,
                    onClick: () => _ctx.onBookingCargo(option, 'manual')
                  }, null, 8, ["icon", "type", "origin", "isActive", "destination", "onClick"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}